import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StatusService } from '../services/status.service';

@Component({
  selector: 'app-spinner',
  imports: [CommonModule],
  templateUrl: './spinner.component.html',
  styleUrl: './spinner.component.scss',
  standalone: true,
})
export class SpinnerComponent {
  constructor(public loadingStatus: StatusService) {}
}
